/**
 * Normalize a value for user-input comparison: trimmed, lower-cased and
 * stripped of diacritics, so that "Premières Couches" and "premieres couches"
 * compare as equal.
 */
export default function normalizeForComparison(value) {
    return String(value ?? '')
        .trim()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
}
